var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12L12 6M8 3L8.463 2.464C9.4008 1.52633 10.6727 0.999601 11.9988 0.999695C13.325 0.999789 14.5968 1.52669 15.5345 2.4645C16.4722 3.40231 16.9989 4.67419 16.9988 6.00035C16.9987 7.32652 16.4718 8.59833 15.534 9.536L15 10M10 15L9.60299 15.534C8.65399 16.4717 7.37363 16.9976 6.0395 16.9976C4.70536 16.9976 3.425 16.4717 2.476 15.534C2.00811 15.0717 1.63663 14.5212 1.3831 13.9143C1.12956 13.3074 0.999008 12.6562 0.999008 11.9985C0.999008 11.3408 1.12956 10.6896 1.3831 10.0827C1.63663 9.4758 2.00811 8.92526 2.476 8.463L3 8",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/LinkIcon.5c9e40937340e52fe7e7b8ec67aa0c4c.svg";
export { ForwardRef as ReactComponent };